<div class="registrations-action-cell" (click)="$event.stopPropagation()">
  <button
    type="button"
    class="action-trigger"
    (click)="handleRenewClick()"
  >
    <wm-common-text [data]="{ text: row?.renewLabel || 'Renew' }"></wm-common-text>
  </button>
</div>
